import { create } from 'zustand'
export const useReportVouchersSentStore = create(set => ({
  reportVouchersSentData: null,
  setReportVouchersSentData: data =>
    set(() => ({ reportVouchersSentData: data })),

  reportVouchersSentDataSuccess: null,
  setReportVouchersSentDataSuccess: data =>
    set(() => ({ reportVouchersSentDataSuccess: data })),

  dateExpiryStart: null,
  setDateExpiryStart: date => set(() => ({ dateExpiryStart: date })),

  dateExpiryEnd: null,
  setDateExpiryEnd: date => set(() => ({ dateExpiryEnd: date })),

  isLoading: false,
  setIsLoading: loading => set(() => ({ isLoading: loading })),

  tabValue: 0,
  setTabValue: value => set(() => ({ tabValue: value })),

  voucherBalance: 0,
  setVoucherBalance: value => set(() => ({ voucherBalance: value })),

  voucherCount: 0,
  setVoucherCount: value => set(() => ({ voucherCount: value })),

  resetStore: () =>
    set(() => ({
      reportVouchersSentData: null,
      reportVouchersSentDataSuccess: null,
      dateExpiryStart: null,
      dateExpiryEnd: null,
      isLoading: false,
      tabValue: 0,
      voucherBalance: 0,
      voucherCount: 0,
    })),
}))
